export default "__VITE_ASSET__93b0cc73__"